import { Toaster } from "sonner";
import { Navbar } from "../components/Navbar";
import { Hero } from "../components/Hero";
import { TrustMarquee } from "../components/TrustMarquee";
import { About } from "../components/About";
import { Services } from "../components/Services";
import { Products } from "../components/Products";
import { Advantages } from "../components/Advantages";
import { Process } from "../components/Process";
import { Portfolio } from "../components/Portfolio";
import { Specs } from "../components/Specs";
import { QuoteSection } from "../components/QuoteSection";
import { Testimonials } from "../components/Testimonials";
import { Faq } from "../components/Faq";
import { BigCta } from "../components/BigCta";
import { Contact } from "../components/Contact";
import { Footer } from "../components/Footer";
import { FloatingWa } from "../components/FloatingWa";

export default function Home() {
  return (
    <main className="bg-navy-950 text-frost" data-testid="home-page">
      <Navbar />
      <Hero />
      <TrustMarquee />
      <About />
      <Services />
      <Products />
      <Advantages />
      <Process />
      <Portfolio />
      <Specs />
      <QuoteSection />
      <Testimonials />
      <Faq />
      <BigCta />
      <Contact />
      <Footer />
      <FloatingWa />
      <Toaster theme="dark" position="top-center" richColors />
    </main>
  );
}
